<template>
  <main-template>
    <form @submit.prevent="handleAgree" method="post">

     <div class="header"></div>
        <div class="form form-additional">
            <div class="reading-text">
                <div class="hspace"></div>
                <span class="span1">1．お客様に関する情報の取得・利用について</span><br>
                <div class="hspace"></div>
                <span class="span2">弊社は、本件事故の保険金請求に際して、お客様のお名前、ご連絡先、事故状況、車の損害状況やその所有者、おけがの容態などの個人情報について、円滑な事故解決、適正な保険金のお支払い、事故調査（医療機関、修理業者、警察・消防、事故当事者等に対する照会等を含みます。）、保険金不正請求等の犯罪防止・排除のために必要な範囲で取得・利用させていただきます。</span>
                <div class="hspace"></div>
                <span class="span1">2．お客様に関する情報の第三者提供について</span>
                <div class="hspace"></div>
                <span class="span2">弊社は、本件事故の保険金請求に際して、円滑な事故解決、適正な保険金のお支払い、事故調査、保険金不正請求等の犯罪防止・排除のため、取得したお客様の情報を下記の第三者などにお伝えすることがあります。</span><br>
                <span class="span2">・事故当事者</span><br>
                <span class="span2">・事故当事者の関係する保険会社</span><br>
                <span class="span2">・保険契約者</span><br>
                <span class="span2">・保険契約取扱代理店</span><br>
                <span class="span2">・修理業者</span><br>
                <span class="span2">・医療機関</span><br>
                <span class="span2">・警察・消防</span><br>
                <span class="span2">など</span>
                <div class="hspace"></div>
            </div>
            <input name="__RequestVerificationToken" type="hidden" value="2k2O2_Wuq60TdQxYLz3dZ3ixwxmf1HHdzrPK21Yz6wtuYlkJT7AIiKYvEUB3sGRr6GrHLCq4kPeAqxRHp-9a8iAmJKwFdnZV8PgZsusQGZI1">
            <div class="btn_box">
                <!-- <button type="button" class="btn btn-outline-secondary" onclick="location.href='javascript:history.back()'">戻る</button> -->
                <input type="submit" class="btn btn-success" value="同意する">
            </div>
        </div>
    </form>
  </main-template>
</template>

<script setup lang="ts">
import MainTemplate from '@/components/MainTemplate.vue'
import router from '@/router'

const handleAgree = () => {
  router.push('/fnol-form')
}

</script>

<style scoped>
 .scroll-box span{
    overflow-y: scroll;
}

.scroll-box {
    height:400px;
}

.span1{
    font-weight:bold;
}

.hspace{
    height:10px;
}

.btn_box{
  border-top:solid 1px darkred;
  width:100%;
  display:flex;
  flex-direction: row;
  gap: 10px;
}
.btn_box button {
  flex: 1;
  margin: 10px 0;
}

.btn_box input{
  flex: 1;
  margin: 10px 0;
}

.btn-success{
  width:100%;
}

.form-additional {
  max-width: 800px;
  margin: 76px auto 0;
  padding: 0 20px;
  width: 100%;
  text-align: left;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .form-additional {
    max-width: 750px;
    margin: 76px auto 0;
    padding: 0 5px;
  }
  .btn_box {
    flex-direction: column;
  }
  .btn_box button,
  .btn_box input {
    width: 100%;
  }
  .span1 {
    font-size: 16px;
  }
  .span2 {
    font-size: 14px;
  }
}

@media (max-width: 1024px) and (min-width: 769px) {
  .form-additional {
    max-width: 850px;
    padding: 0 20px;
  }
}

@media (min-width: 1025px) {
  .form-additional {
    max-width: 1200px;
    padding: 0 30px;
  }
}
</style>
